import {useMemo, useState} from 'react';
import {useDebounce} from 'react-use';
import {containsSearchString} from 'app/components/FleetManager/utils';
import {Files, sortByDateDesc} from 'app/components/entities/files';

export function useFilterAndSortFiles(recordings: Files.Recording[]) {
  const [search, setSearch] = useState('');
  const [sharedOnly, setSharedOnly] = useState(false);
  const [period, setPeriod] = useState<[number, number] | undefined>(undefined);
  const [debouncedSearch, setDebouncedSearch] = useState('');

  const searchTrim = search.trim();

  useDebounce(
    () => {
      setDebouncedSearch(searchTrim);
    },
    500,
    [searchTrim],
  );

  const filtered = useMemo(() => {
    let copy = [...recordings];

    if (debouncedSearch) {
      copy = copy.filter((r) => containsSearchString(r.name, debouncedSearch));
    }

    if (sharedOnly) {
      copy = copy.filter((r) => r.share);
    }

    if (period) {
      copy = copy.filter((r) => r.startAt >= period[0] && r.endAt <= period[1]);
    }

    return copy.sort(sortByDateDesc);
  }, [recordings, debouncedSearch, sharedOnly, period]);

  return {filtered, search, period, sharedOnly, setPeriod, setSharedOnly, setSearch};
}
